<template>
    <div class="gh-sidebar">
        <gh-sidebar-trigger @toggle="toggleSidebarOnMobile"></gh-sidebar-trigger>

        <div :class="wrapperClasses">
            <div class="gh-sidebar__container">
                <div class="gh-sidebar__header" @click="toggleSidebarOnMobile" v-if="isTouch">
                    <p class="label">{{ heading }}</p>
                    <i class="el-icon-close icon"></i>
                </div>

                <slot name="menu"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import ghSidebarTrigger from './trigger.vue';

    export default {
        components: {ghSidebarTrigger},

        props: {
            heading: {
                type: String,
                default: 'Menu'
            }
        },

        computed: {
            wrapperClasses() {
                return {
                    'gh-sidebar__wrapper': true,
                    'is-mobile': this.isTouch,
                    'is-visible': this.visibilityOnMobile
                }
            },

            isTouch() {
                return this.$store.state.ui.isTouch;
            },

            visibilityOnMobile() {
                return this.$store.state.ui.sidebarVisibilityOnMobile;
            }
        },

        methods: {
            toggleSidebarOnMobile() {
                this.isTouch && this.$store.commit('ui/TOGGLE_SIDEBAR_VISIBILITY_ON_MOBILE');
            },
        },

        watch: {
            visibilityOnMobile(state) {
                const body = document.getElementsByTagName('body')[0];

                if (state) {
                    body.style.overflow = 'hidden';
                } else {
                    body.style.overflow = 'auto';
                }
            }
        },
    }
</script>